module.exports = __webpack_public_path__ + "/build/web/images/logos/budget-blinds/budget-blinds.33a97463da9ccf39ceaef36b58b56ddb.png";


//////////////////
// WEBPACK FOOTER
// ./images/logos/budget-blinds/budget-blinds.png
// module id = 160
// module chunks = 13